import { OccurrenceCountFormField } from '@/domain/termine/features/CreateTermin/shared/FormFields/IndividuelleWiederholung/OccurrenceCountFormField';
import { WeekdayOccurrenceSelectFormField } from '@/domain/termine/features/CreateTermin/shared/FormFields/IndividuelleWiederholung/WeekdayOccurrenceSelectFormField';
import { DatePickerFormField } from '@/domain/termine/features/CreateTermin/shared/FormFields/DatePickerFormField';
import { RepeatIntervalSelectFormField } from '@/domain/termine/features/CreateTermin/shared/FormFields/IndividuelleWiederholung/RepeatIntervalSelectFormField';
import { WeekdaySelectFormField } from '@/domain/termine/features/CreateTermin/shared/FormFields/IndividuelleWiederholung/WeekdaySelectFormField';
import { useCreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/useCreateTermineFormContext';
import { TerminWiederholungsIntervall } from '@/domain/termine/shared/types/TerminWiederholungsIntervall';
import { Card, CardContent } from '@e2n/ui';
import { useTranslation } from 'react-i18next';

export function IndividuelleWiederholungCard() {
  const { t } = useTranslation();
  const { form } = useCreateTermineFormContext();

  return (
    <Card className="bg-neutrals-200">
      <CardContent className="space-y-4 p-4">
        <div className="space-y-2.5">
          <p className="text-xs font-bold text-neutrals-900">
            {t('domain.termine.form.wiederholungLabel')}
          </p>

          <div className="flex flex-row gap-4">
            <OccurrenceCountFormField />
            <RepeatIntervalSelectFormField />
          </div>
        </div>
        <form.Subscribe
          selector={(state) => state.values.wiederholungsIntervall}>
          {(wiederholungsIntervall) =>
            wiederholungsIntervall === TerminWiederholungsIntervall.MONAT ||
            wiederholungsIntervall === TerminWiederholungsIntervall.JAHR ? (
              <WeekdayOccurrenceSelectFormField />
            ) : (
              wiederholungsIntervall === TerminWiederholungsIntervall.WOCHE && (
                <WeekdaySelectFormField />
              )
            )
          }
        </form.Subscribe>
        <DatePickerFormField name="wiederholungBis" />
      </CardContent>
    </Card>
  );
}
